<template>
  <section>
    <vs-row vs-justify="center" class="vx-row w-auto">
      <!-- Member -->
      <vs-col class="vx-col w-full">
        <vx-card class="cardx">
          <vs-tabs class="tab-action-btn-fill-container">
            <vs-tab label="Profile" icon-pack="feather" icon="icon-user">
              <div class="tab-text">
                <stool-test-profile
                  ref="profile"
                  :locked="locked"
                  @locked="(value) => (this.locked = value)"
                />
              </div>
            </vs-tab>
            <vs-tab label="Gut Check" icon-pack="feather" icon="icon-check">
              <div class="tab-text">
                <stool-test-gut ref="gut" />
              </div>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </vs-col>

      <!-- Tracking History -->
      <vs-col class="vx-col w-full">
        <vx-card class="cardx" title="Tracking History">
          <stool-tracking-history-table @edit="openTrackingForm" />

          <hr v-show="!tracking" class="my-4" />

          <div class="vx-row">
            <div class="vx-col w-full text-center">
              <vs-button
                v-show="!tracking"
                transition="fadeOut"
                class="mx-auto"
                icon-pack="feather"
                icon="icon-plus-square"
                @click="openTrackingForm"
                :disabled="locked"
              >
                Create New Tracking
              </vs-button>
            </div>
          </div>
        </vx-card>

        <stool-tracking
          v-if="tracking"
          ref="tracking"
          transition="fadeIn"
          @success="reloadTrackingHistory"
          @remove="closeTrackingForm"
        />
      </vs-col>
    </vs-row>

    <!-- Back Button -->
    <vs-row vs-justify="flex-start" class="my-4">
      <vs-button
        color="primary"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click.prevent="$router.go(-1)"
      >
        Back
      </vs-button>
    </vs-row>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex' //

import infoMixin from '@/mixins/infoMixin'
import formMixin from '@/mixins/stool-questionnaire/formMixin'
import schemas from '@/utils/schemas'
import StoolTestProfile from '@/components/form/stool-questionnaire/profile'
import StoolTestGut from '@/components/form/stool-questionnaire/gut'
import StoolTracking from '@/components/form/stool-questionnaire/tracking'
import StoolTrackingHistoryTable from '@/components/table/StoolTrackingHistory'

export default {
  mixins: [infoMixin, formMixin],
  components: {
    StoolTestProfile,
    StoolTestGut,
    StoolTracking,
    StoolTrackingHistoryTable
  },
  data: () => ({
    breadcrumb: [{ title: 'Update Stool Questionnaire', active: true }],
    newTracking: false,
    activeTab: 0
  }),
  computed: {
    ...mapGetters('stoolQuestionnaire', ['profile', 'trackings', 'tracking']),
    //   'info',
    //   'stoolTrackings',
    //   'stoolTracking'
    // ]),
    ...mapGetters('stoolTracking', {
      tracking: 'info'
    })
  },
  methods: {
    ...mapActions('stoolQuestionnaire', [
      'find',
      'update',
      'fetchTrackings',
      'reset'
    ]),
    //
    // async validateForm () {
    //   const validates = [this.$refs.profile.validate()]
    //
    //   const valids = await Promise.all(validates)
    //
    //   return valids.every(valid => valid)
    // },
    // async saveChanges () {
    //   const valid = await this.validateForm()
    //
    //   /* eslint-disable */
    //   if (!valid) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: 'Please complete this form',
    //       iconPack: 'feather',
    //       icon: 'icon-error',
    //       color: 'warning'
    //     })
    //     return
    //   }
    //
    //   this.locked = true
    //
    //   await Promise.all([
    //       this.info.id ?
    //         this.update({ id: this.info.id, data: this.info }) :
    //         this.create({ data: this.info })
    //     ])
    //     .then(() => {
    //       this.$vs.notify({
    //         title: 'Success',
    //         text: `Stool Questionnaire has been ${this.info.id ? 'updated' : 'created'}`,
    //         iconPack: 'feather',
    //         icon: 'icon-check-circle',
    //         color: 'success'
    //       })
    //     })
    //     .catch(() => {
    //       this.$vs.notify({
    //         title: 'Error',
    //         text: 'Update fail',
    //         iconPack: 'feather',
    //         icon: 'icon-error',
    //         color: 'danger'
    //       })
    //     })
    //     .finally(() => {
    //       this.locked = false
    //     })
    // },

    openTrackingForm(data = null) {
      // console.log({ methods: 'openTrackingForm', data })
      const _schema = schemas.stoolTracking()

      if (this.lodash.isObject(data)) {
        Object.assign(_schema, data)
      }

      // console.log({ _schema })
      this.$store.commit('stoolTracking/SET_INFO', _schema)
    },
    closeTrackingForm() {
      this.$store.commit('stoolTracking/RESET_INFO')
    },
    reloadTrackingHistory() {
      const { id } = this.$route.params

      this.fetchTrackings({
        id
      })
    }
  },
  async mounted() {
    const { id } = this.$route.params

    this.locked = true

    if (id) {
      await this.find({
        id: parseInt(id, 10)
      })
      this.reloadTrackingHistory()
    }

    // if (this.lodash.has(this.$route, 'query[new-case]')) {
    //   this.openTrackingForm()
    // }

    this.locked = false
  }
}
</script>

<style lang="scss">
.cardx {
  margin-bottom: 20px;
}
.cardx .vx-card__body,
.cardx .vx-card__body .con-vs-tabs,
.cardx .vx-card__body .con-vs-tabs .con-slot-tabs {
  overflow: visible !important;
}
</style>
